<template>
    <div>
        <div class="environment">マルチアングルスワイプ版&nbsp;{{ environment }}</div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="left" label-width="0px"
                 class="demo-ruleForm login-container">
            <h3 class="title">ログイン</h3>
            <el-form-item prop="account">
                <el-input type="text" v-model="ruleForm.account" auto-complete="off" placeholder="ID"></el-input>
            </el-form-item>
            <el-form-item prop="checkPass">
                <el-input type="password" v-model="ruleForm.checkPass" auto-complete="off"
                          placeholder="Password"></el-input>
            </el-form-item>
            <el-checkbox v-model="checked" checked class="remember">記憶する</el-checkbox>
            <el-form-item style="width:100%;">
                <el-button type="primary" style="width:100%;" @click.native.prevent="handleSubmit" :loading="logining">ログイン
                </el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import * as Session from '../api/session';
    import * as User from '../api/cognitoUser';
    import config from '../config/app';

    export default {
        data() {
            return {
                environment: "",
                logining: false,
                ruleForm: {
                    account: "",
                    checkPass: ""
                },
                rules: {
                    account: [
                        { required: true, message: 'アカウント名を入力してください。', trigger: 'blur' },
                    ],
                    checkPass: [
                        { required: true, message: 'パスワードを入力してください。', trigger: 'blur' },
                    ]
                },
                checked: true
            };
        },
        methods: {
            handleReset() {
                this.$refs.ruleForm.resetFields();
            },
            handleSubmit(ev) {
                const _this = this;
                this.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        //_this.$router.replace('/table');
                        this.logining = true;
                        const loginParams = {
                            username: this.ruleForm.account,
                            password: this.ruleForm.checkPass
                        };
                        Session
                            .login(loginParams)
                            .then(data => {
                                this.logining = false;

                                const attributes = JSON.parse(sessionStorage.getItem('attributes'));
                                // console.log(attributes);
                                if (attributes["custom:isAdmin"] && attributes["custom:isAdmin"] === "true") {
                                    // 一般ユーザの場合、動画管理に遷移
                                    if (!User.checkAdminRoleBySession()) {
                                        this.$router.push({ path: '/contents/movies' });
                                    } else {
                                        this.$router.push({ path: '/users/list' });
                                    }
                                } else {
                                    this.$router.push({ path: '/users/contents' });
                                }
                            })
                            .catch(err => {
                                this.$message({
                                    message: 'ログインに失敗しました。',
                                    type: 'warning'
                                });
                            });
                    } else {
                        return false;
                    }
                });
            },
            getEnvironment() {
                const env = config.environment;
                switch (env) {
                    case 'prd': return '商用環境';
                    case 'stg': return '検証環境';
                    default: return '開発環境';
                }
            }
        },
        mounted() {
            this.environment = this.getEnvironment();
        }
    }

</script>

<style lang="scss" scoped>
    .login-container {
        /*box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);*/
        -webkit-border-radius: 5px;
        border-radius: 5px;
        -moz-border-radius: 5px;
        background-clip: padding-box;
        margin: 0 auto 180px auto;
        width: 350px;
        padding: 35px 35px 15px 35px;
        background: #fff;
        border: 1px solid #eaeaea;
        box-shadow: 0 0 25px #cac6c6;
        .title {
            margin: 0px auto 40px auto;
            text-align: center;
            color: #505458;
        }
        .remember {
            margin: 0px 0px 35px 0px;
        }
    }
    .environment {
        font-size: 1.3rem;
        width: 350px;
        margin: 130px auto 20px auto;
        font-weight: 500;
        text-align: center;
    }
</style>


// WEBPACK FOOTER //
// Login.vue?43f9f8d4